<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold cl-agen-dark">Bonus History</div>
		</div>
		<div class="mt-2">
			<div class="d-flex flex-wrap justify-end" >
				<v-col cols="12" sm="4" md="3" lg="2" class="px-0">
					<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field placeholder="Select period" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-xl date-no-border" hide-details :value="convertMonth(dateStart)"></v-text-field>
						</template>
						<v-date-picker locale="en" type="month" first-day-of-week="0" color="red darken-3	" :max="today" @input="startDate = false" @change="changeDate" v-model="dateStart"></v-date-picker>
					</v-menu>
				</v-col>
			</div>
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listHistoryKomisi.length > 0 && userData.member_id !== '1'">
					<v-col cols="12" class="d-none d-md-block">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left">Date</th>
										<th class="text-left">Sponsor</th>
										<th class="text-left">Match</th>
										<th class="text-left">Unilevel</th>
										<th class="text-left">Cashback</th>
										<th class="text-right">Total</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="bonus in listHistoryKomisi" :key="bonus.bonus_log_id">
										<td>{{ bonus.bonus_log_date | toDate}}</td>
										<td class="text-left cl-primary text-capitalize">{{ bonus.bonus_log_sponsor | toCurrencyFormat }}</td>
										<td class="text-left cl-primary text-capitalize">{{ bonus.bonus_log_match | toCurrencyFormat }}</td>
										<td class="text-left cl-primary text-capitalize">{{ bonus.bonus_log_unilevel | toCurrencyFormat }}</td>
										<td class="text-left cl-primary text-capitalize">{{ bonus.bonus_log_cashback | toCurrencyFormat}}</td>
										<td class="text-right cl-primary text-capitalize">{{ totalBonus(bonus) | toCurrencyFormat}}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="12" class="d-block d-md-none">
						<v-card elevation="1" class="mb-3 elevation-0 hover-shadow pa-3 rounded-xl" v-for="bonus in listHistoryKomisi" :key="bonus.bonus_log_id">
							<div class="d-flex align-center justify-start font-size-10 mb-4">
								<span class="d-flex align-center black--text font-weight-500"><v-icon dense class="mr-2">mdi-calendar-outline</v-icon>{{ bonus.bonus_log_date | toDay }}, {{ bonus.bonus_log_date | toDate }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Sponsor</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_sponsor | toCurrencyFormat }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Match</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_match | toCurrencyFormat }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Unilevel</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_unilevel | toCurrencyFormat }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Cashback</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_cashback | toCurrencyFormat }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-11 mt-5">
								<span class="cl-secondary font-weight-600">Total (RM)</span>
								<span class="cl-primary font-weight-600">{{  totalBonus(bonus) | toCurrencyFormat }}</span>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<div class="mt-3" v-if="listHistoryKomisi.length == 0 || userData.member_id == '1'">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center primary--text">No bonus history data available.</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoryKomisi.length > 0 && userData.member_id !== '1'">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyKomisiPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Showing {{ historyKomisiPagination.total_display }} data from {{ historyKomisiPagination.total_data }} data</div>
						</v-col>
						<v-col cols="3" sm="2" md="1">
							<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			userData: null,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			startDate: false,
			dateStart: moment().format("YYYY-MM"),
			monthYear: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			month: '',
			year: '',
			params: [],
		}
	},
	computed: {
		...mapState('komisi', ['listHistoryKomisi', 'historyKomisiPagination']),
	},
	methods: {
		...mapActions('komisi', ['getHistoryKomisi']),

		getData() {
			this.loading = true
			
			let type = {
				type: 'string',
				field: 'bonus_log_type',
				comparison: '=', 
				value: 'in',
			}
			let month = {
				type: 'string',
				field: 'bonus_month',
				comparison: '=', 
				value: this.dateStart.split('-')[1],
			}
			let year = {
				type: 'string',
				field: 'bonus_year',
				comparison: '=', 
				value: this.dateStart.split('-')[0],
			}
			this.params.push(type)
			this.params.push(month)
			this.params.push(year)
			this.getHistoryKomisi(this.queryString({sort: 'bonus_log_datetime', dir: 'DESC', page: '1', limit: '10', params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changeDate() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		totalBonus(bonus) {
			return parseInt(bonus.bonus_log_cashback)+parseInt(bonus.bonus_log_unilevel)+parseInt(bonus.bonus_log_match)+parseInt(bonus.bonus_log_sponsor)
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Bonus History`)
		const authData = localStorage.getItem('mlmcore-vo-auth-data');
		this.userData = JSON.parse(authData)
		this.getData()
	}
};
</script>

